/* global axios */
import ApiClient from './ApiClient';

// Modelos salvos da campanha WhatsApp ao vivo (v87).
class LiveCampaignPresetsAPI extends ApiClient {
  constructor() {
    super('live_campaign_presets', { accountScoped: true });
  }

  list() {
    return axios.get(this.url);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new LiveCampaignPresetsAPI();
